import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { FormGroup, FormControl, FormBuilder, NgForm } from '@angular/forms';
import { switchMap } from 'rxjs/operators';
import { LoadJsService } from '../../load-js/load-js.service';
import { ApiPartnerService } from '../../api/api-partner.service';

@Component({
  selector: 'app-manage-prov',
  templateUrl: './manage-prov.component.html',
  styleUrls: ['./manage.component.css']
})
export class ManageProvComponent implements OnInit {

  Listprovisioning: any = [];
  Listchannel: any = [];
  Billing: any = [];
  Productsource: any = [];
  Provisioning: any = [];
  response: any = {};
  paging : any = {};
  itemdihapus: any = {};
  itemview: any = {};


  constructor(
    private route: ActivatedRoute,
    private fb: FormBuilder,
	  private router: Router,
    public LoadJsOrder: LoadJsService,
	  public partnerService: ApiPartnerService
  ) { }

  formOrder = this.fb.group({
    id: [''],
    productname: [''],
    billingtype: [''],
    startdate: [''],
    enddate: [''],
    price: [''],
    age: [''],
    productsource: [''],
    provisioningcode: ['']
  })
  btn_save = true
  btn_save_disable = false
  btn_loading = false
  loading_create = false
  alert_failed = false
  alert_success = false
  buttonUpdate = false
  buttonSave = true
  hidId = false

  isNew = false;
  table_load = false
  datachannel = false
  loadspin = false
  datanull = false
  data404 = false
  apimessage:any = {}

  msearch : string;
  
  meta = [];
  self = [];
  page_self = [];
  page_next = [];
  page_prev = [];
  last_index : number;
  first_index : number;
  total_count : number;
  querySearch = false;
  searching = false;
  dataempty = true;
  currentParams = {};
  queryParams = '';
  searchQueryParams = '';
  href='';

  alert_act='';


  ngOnInit() {
    this.loadStart();
  }
  
  loadStart() {
    
    this.route.queryParams
      //.filter(params => params.order)
      .subscribe(params => {
        console.log(params); // {order: "popular"}

        //this.order = params.order;
        //console.log(this.order); // popular

        if (params.search != '' && params.search != undefined ){
          console.log('search');
          console.log(params.search);
         this.msearch = params.search; 
         this.querySearch = true;
        

         this.currentParams = params;
         this.queryParams = '?'+this.queryStr(params);
         this.loadProvisioning(this.queryParams);
        
        }else{
          this.querySearch = false;
          this.currentParams = params;

          this.queryParams = '?'+this.queryStr(params);
          console.log(this.queryParams);
          console.log(this.queryStr(params));
          /* pagination */
          //this.loadworkorder(this.currentParams);
          this.loadProvisioning(this.queryParams);
        }
      });
    this.loadBilling();
    this.loadProductsource();
  }

  refreshPage() {
    this.ngOnInit();
  }

  queryStr(options: any){
    let params = new URLSearchParams();
    for(let key in options){
        params.set(key, options[key]) 
    }
    return params.toString();
  }

  search()
  {
    this.querySearch = true;
    this.searchQueryParams = this.queryParams+'&search='+this.msearch;
    this.loadProvisioning(this.searchQueryParams);
  }

  buttonCreate() {
    // this.buttonUpdate = false;
    // this.buttonSave = true;

    this.isNew = true;
    this.clearForm();
  }


  clearForm() {
    this.formOrder.reset();
  }

  onActionClick(act:any, item: any)
  {
    // console.log(item);
    this.alert_act = act;

    if ( act == "hapus") {
      this.itemdihapus = item
    }
    else if ( act == "view") {
      this.itemview = item
      console.log(this.itemview)   
      this.Listchannel = []   
      this.datanull = false
      this.data404 = false

      this.onUpdate(item)
    }
  }

  onUpdate(data: any)
  {
    this.loadspin = true
    const post = { "code_product": data.provisioningcode }
    return this.partnerService.GetChannelbyproduct(post).subscribe((output: any) => {
      console.log(output)
      this.loadspin = false
      if( output.status != 404 ){
        this.Listchannel = output.rest.data

        if(this.Listchannel.length != 0){
          this.datachannel = true
        }else{
          this.datanull = true
        }
      }else{
        this.apimessage = output.message
        this.loadspin = false
        this.data404 = true
      }
    })
  }

  onDelete(item: any, el: HTMLElement)
  {

    console.log(item)
    return this.partnerService.SetDeleteproductsale(item.id).subscribe((output: any) => {
      this.ngOnInit()

      console.log(output.data);
      this.alert_success = true
      setTimeout(()=>{
        el.scrollIntoView({behavior:"smooth"})
      }, 500);
      setTimeout(()=>{
        this.alert_success = false
      }, 6000);
    })
  }
  
  submitSave(el: HTMLElement) {
    this.btn_save = false
    this.loading_create = true
    this.btn_save_disable = true
    this.btn_loading = true
    // console.log(this.formOrder.value)
    this.partnerService.PostCreateproduct(this.formOrder.value).subscribe((data: any) => { 
        this.response = data
        console.log(this.response)
        if (this.response.status == true) {
          
          this.btn_save = true
          this.btn_save_disable = false
          this.loading_create = false
          this.ngOnInit()
          this.LoadJsOrder.loadScriptProductStb()
          this.alert_success = true
        
          setTimeout(()=>{
            el.scrollIntoView({behavior:"smooth"})
          }, 500);
          setTimeout(()=>{
            this.alert_success = false
          }, 6000);
        } else {
          
          this.btn_save = true
          this.btn_save_disable = false
          this.loading_create = false
          this.LoadJsOrder.loadScriptProductStb()
          this.alert_failed = true
        
          setTimeout(()=>{
            el.scrollIntoView({behavior:"smooth"})
          }, 500);
          setTimeout(()=>{
            this.alert_failed = false
          }, 6000);
        }
      
      }
    );
  }

  submitUpdate(el: HTMLElement) {
    this.btn_save = false
    this.loading_create = true
    this.btn_save_disable = true
    this.btn_loading = true
    // console.log(this.formOrder.value)
    this.partnerService.SetUpdateproductsale(this.formOrder.value)
      .subscribe((data: {}) => { 
        this.response = data
        console.log(this.response)
        if (this.response.status == true) { 

          this.btn_save = true
          this.btn_save_disable = false
          this.loading_create = false
          this.ngOnInit()
          this.LoadJsOrder.loadScriptProductStb()
          this.alert_success = true
          
          setTimeout(()=>{
              el.scrollIntoView({behavior:"smooth"})
            }, 500);
            setTimeout(()=>{
              this.alert_success = false
            }, 6000);
        } else {
          
          this.btn_save = true
          this.btn_save_disable = false
          this.loading_create = false
          this.LoadJsOrder.loadScriptProductStb()
          this.alert_failed = true
          setTimeout(()=>{
            el.scrollIntoView({behavior:"smooth"})
          }, 500);
          setTimeout(()=>{
            this.alert_failed = false
          }, 6000);
        }
      
      }
    );
  }

  loadBilling() {
    return this.partnerService.GetBillingtype().subscribe((output: any) => {
      this.Billing = output.data;
    })
  }

  loadProductsource() {
    return this.partnerService.GetProductsource().subscribe((output: any) => {
      this.Productsource = output.data;
    })
  }


  loadProvisioning(params: any) {
    this.table_load = true;
    return this.partnerService.GetListprovisioning(params).subscribe((output: any) => {
    console.log(output);
      this.Listprovisioning = output.data;

      this.table_load = false;

      this.paging = output.pagex;
      this.page_self = output.pagex.self;
      this.page_next = output.pagex.next;
      this.page_prev = output.pagex.prev;
      this.meta = output.meta;
      this.total_count = this.meta['totalCount'];
      let self = this.page_self['page'];
      if ( self * this.meta['perPage'] < this.meta['totalCount']){
        this.last_index = (self * this.meta['perPage']);
      }else{
        this.last_index = this.meta['totalCount'];
      }
      
      this.first_index = ((self-1)*this.meta['perPage'])+1;
    })
  }
}
